import axios from "axios";

const cupos = {
  state: () => ({
    cupos: [],
    cupo: {},

    cuposCampesena: [],
    cupoCampesena: {},

  }),

  getters: {
    obtenerCupos: (state) => (categoria) => {
      return state.cupos.filter((cupo) => cupo.categoria_id == categoria);
    },

    obtenerCuposAsignados: (state) => (centroFormacion) => {
      return state.cupos.filter(cupo => cupo.centro_formacion_id == centroFormacion)
    },

    obtenerCupoAsignadoCategoria: (state) => (centroFormacion, categoria) => {
      return state.cupos.find(cupo => cupo.centro_formacion_id == centroFormacion && cupo.categoria_id == categoria)
    },

    obtenerCupo(state) {
      return state.cupo;
    },

    obtenerCuposCampesena: (state) => (saberId) => {
      return state.cuposCampesena.filter((cupo) => cupo.saber_id == saberId);
    },

    obtenerCupoCampesena(state) {
      return state.cupoCampesena;
    },

    obtenerCuposCentroFormacionCampesena: (state) => (centroId) => {
      return state.cuposCampesena.filter((cupo) => cupo.centro_formacion_id == centroId);
    },
    
    obtenerCupoAsignadoSaberCampesena: (state) => (centroFormacion, saber) => {
      return state.cuposCampesena.find(cupo => cupo.centro_formacion_id == centroFormacion && cupo.saber_id == saber)
    },
  },

  mutations: {
    enviarCupos(state, cupos) {
      state.cupos = cupos;
    },

    enviarCupo(state, cupo) {
      state.cupo = cupo;
    },

    enviarCuposCampesena(state, cupos) {
      state.cuposCampesena = cupos;
    },

    enviarCupoCampesena(state, cupo) {
      state.cupoCampesena = cupo;
    },
  },

  actions: {
    registrarCupo(context, cupo) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/cupos", cupo)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    gestionarCupos(context, competencia) {
      axios.get("api/competencias/" + competencia + "/cupos")
        .then((response) => {
          const cupos = [];

          response.data.results.forEach((cupo) => {
            cupos.push({
              id_cupo: cupo.id_cupo,
              competencia_id: cupo.competencia.id_competencia,
              competencia: cupo.competencia.competencia,
              categoria_id: cupo.categoria.id_categoria,
              categoria: cupo.categoria.categoria,
              regional_id: cupo.centro_formacion.regional.id_regional,
              regional: cupo.centro_formacion.regional.regional,
              centro_formacion_id: cupo.centro_formacion.id_centro_formacion,
              centro_formacion: cupo.centro_formacion.centro_formacion,
              numero_participantes: cupo.numero_participantes,
            });
          });

          context.commit("enviarCupos", cupos);
        })
        .catch(() => {});
    },

    detallesCupo(context, id) {
      axios.get("api/cupos/" + id)
        .then((response) => {
          const results = response.data.results;

          const cupo = {
            id_cupo: results.id_cupo,
            competencia_id: results.competencia.id_competencia,
            competencia: results.competencia.competencia,
            categoria_id: results.categoria.id_categoria,
            categoria: results.categoria.categoria,
            regional_id: results.centro_formacion.regional.id_regional,
            regional: results.centro_formacion.regional.regional,
            centro_formacion_id: results.centro_formacion.id_centro_formacion,
            centro_formacion: results.centro_formacion.centro_formacion,
            numero_participantes: results.numero_participantes,
          };

          context.commit("enviarCupo", cupo);
        })
        .catch(() => {});
    },

    actualizarCupo(context, cupo) {
      return new Promise((resolve, reject) => {
        axios
          .put("api/cupos/" + cupo.id_cupo, cupo)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    eliminarCupo(context, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete("api/cupos/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },


    // Campesena 
    registrarCupoCampesena(context, cupo) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/campesena/cupos`, cupo)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    gestionarCuposCampesena(context,  competenciaId ) {
      axios
        .get(`/api/campesena/competencias/${competenciaId}/cupos`)
        .then((response) => {
          const cupos = response.data.results.map((item, i) => ({
            indice: i + 1,
            id_cupo: item.id_cupo,
            categoria_id: item.saber.categoria_id,
            saber_id: item.saber_id,
            saber: item.saber.saber,
            competencia_id: item.competencia_id,
            competencia: item.competencia.competencia,
            regional_id: item.centro_formacion.regional_id,
            regional: item.centro_formacion.regional.regional,
            centro_formacion_id: item.centro_formacion.id_centro_formacion,
            centro_formacion: item.centro_formacion.centro_formacion,
            numero_participantes: item.numero_participantes,
          }));
          context.commit("enviarCuposCampesena", cupos);
        })
        .catch(() => {});
    },    
    actualizarCupoCampesena(context, { cupoId, cupo }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/campesena/cupos/${cupoId}`, cupo)
    
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    
    obtenerCupoCampesenaId(context, cupoId) {
        axios
          .get(`/api/campesena/cupos/${cupoId}`)
          .then((response) => {
            const results = response.data.results;
            const cupo = {
              id_cupo: results.id_cupo,
              categoria_id: results.saber.categoria_id,
              saber_id: results.saber_id,
              saber: results.saber.saber,
              competencia_id: results.competencia_id,
              competencia: results.competencia.competencia,
              regional_id: results.centro_formacion.regional_id,
              regional: results.centro_formacion.regional.regional,
              centro_formacion_id: results.centro_formacion.id_centro_formacion,
              centro_formacion: results.centro_formacion.centro_formacion,
              numero_participantes: results.numero_participantes,
            };
            context.commit("enviarCupoCampesena", cupo);
          })
          .catch(() => {});
    },

    eliminarCupoCampesena(context, cupoId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/campesena/cupos/${cupoId}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
};

export default cupos;
